import React from 'react';
import type {BaseControlledListItemType3} from '@Components/controlled-list/components/controlled-list-item-type-3';
import {ControlledListItemType3} from '@Components/controlled-list/components/controlled-list-item-type-3';
import type {ControlledListItem3ActionProps} from '@Components/controlled-list/controlled-list.types';
import {updateListItemSelectionState, updateListSubItemSelectedState} from '../../list-reducer';
import {useAppDispatch, useAppSelector} from '@/hooks';
import type {LIST_ITEM_TYPE, ListDefaultSubItemBaseStorage, ListDefaultItemBaseStorage} from '../../list.types';
import type {ThumbnailData} from '@Components/thumbnail/thumbnail.types';

interface ListItemType3Props {
  id: string;
  listId: string;
}

export interface ListItemType3Storage extends ListDefaultItemBaseStorage, ListBaseItemType3Storage {
  type: LIST_ITEM_TYPE.DEFAULT_3;
  subItems?: ListSubItemStorageType3[];
}

export interface ListBaseItemType3Storage {
  icon?: string;
  subtext?: string;
  actions?: ControlledListItem3ActionProps[];
  containsDangerouslySetText?: boolean;
  thumbnailClassName?: string;
  thumbnail?: ThumbnailData;
  isItemUnmargined?: boolean;
}

export interface ListSubItemStorageType3 extends ListDefaultSubItemBaseStorage, ListBaseItemType3Storage {
  isSelected?: boolean;
}

export function ListItemType3({...props}: ListItemType3Props) {
  const dispatch = useAppDispatch();
  const listItemData = useAppSelector((state) => {
    return state.list.listItemData.listItemsHashMap[props.id] as ListItemType3Storage;
  });

  const onClickListItem = () => {
    dispatch(
      updateListItemSelectionState({
        listId: props.listId,
        id: props.id,
      })
    );

    if (listItemData.onClick) {
      listItemData.onClick(props.listId, props.id);
    }
  };

  const onClickSubItem = (subItemId: string, currentSelectionState?: boolean) => {
    if (!currentSelectionState) {
      dispatch(
        updateListSubItemSelectedState({
          id: subItemId,
          listItemId: props.id,
        })
      );

      const {subItems} = listItemData;
      if (!subItems) {
        return;
      }
      for (let index = 0; index < subItems.length; index++) {
        const subItemObject = subItems[index];
        if (subItemObject.id === subItemId && subItemObject.onClick) {
          subItemObject.onClick(props.id, subItems[index].id);
        }
      }
    }
  };

  const showListItem = () => {
    const subItems: BaseControlledListItemType3[] = [];
    if (listItemData.subItems) {
      for (let index = 0; index < listItemData.subItems?.length; index++) {
        const obj: BaseControlledListItemType3 = {
          id: listItemData.subItems[index].id,
          isSelected: listItemData.subItems[index].isSelected,
          text: listItemData.subItems[index].text,
        };
        subItems.push(obj);
      }
    }

    return (
      <ControlledListItemType3
        id={props.id}
        text={listItemData.text}
        className={listItemData.className}
        subText={listItemData.subtext}
        icon={listItemData.icon}
        subItems={subItems}
        isSelected={listItemData.isSelected}
        onClick={onClickListItem}
        onClickSubItem={(subItemId, currentSelectionState) => {
          onClickSubItem(subItemId, currentSelectionState);
        }}
        actions={listItemData.actions}
        containsDangerouslySetText={listItemData.containsDangerouslySetText}
        thumbnail={listItemData.thumbnail}
        thumbnailClassName={listItemData.thumbnailClassName}
        isItemUnmargined={listItemData.isItemUnmargined}
      />
    );
  };

  return listItemData ? <>{showListItem()}</> : null;
}
